

export const DEFAULT_DEBOUNCE_DELAY = 500;
export const DEFAULT_RETRY_INTERVAL = 5000;
export const DEFAULT_RETRY_COUNT = 3;

export const TEMP_IMAGE_SRC = 'https://pyxis.nymag.com/v1/imgs/51b/28a/622789406b8850203e2637d657d5a0e0c3-avatar-rerelease.rsquare.w400.jpg'

export const EMPTY_STRING = '';

export const INITIAL_PAGE = 1;
export const EMPTY_OPTION_SYMBOL = '\u00A0'; // Non-breaking space

export const FORM_DATA_NULL_VALUE = 'null';


export const MAIN_LAYOUT_PX = 14;

